/**
 * Defines the {@link Header} class.
 * @module
 */
import React, { FC, ReactElement } from "react";
import "./Header.scss";
import { HeaderTypes } from "@componentTypes";
import moment from "moment-timezone";
import { Button } from "@mui/material";
import { LocationOn } from "@mui/icons-material";

/**
 * Props interface for {@link Header}.
 */
interface Props {
    /**
     * The header information for the circular.
     */
    headerInfo: HeaderTypes.HeaderDefinition;
}

/**
 * Generates the circular header component.
 * @param props - The component props.
 * @returns the circular header component.
 */
export const Header: FC<Props> = (props: Props): ReactElement => {
    // Returned JSX.
    return (
        <div className="Header">
            <div className="main-logo-container">
                <img className="main-logo" src={props.headerInfo.logoUrl} alt={""} draggable={false} />
            </div>
            <div className="circular-info">
                <div className="location-info-container">
                    <div className="column-spacer" />
                    <div>
                        <Button
                            className="open-map-button"
                            onClick={() => {
                                window.open(
                                    `https://maps.google.com/?q=${props.headerInfo.latitude},${props.headerInfo.longitude}`,
                                    "_blank",
                                );
                            }}
                        >
                            <LocationOn />
                            {props.headerInfo.storeName}
                        </Button>
                        <div className="address-part-1">{props.headerInfo.address}</div>
                        <div className="address-part-2">
                            {`${props.headerInfo.city}, ${props.headerInfo.state} ${props.headerInfo.zipCode}`}
                        </div>
                    </div>
                </div>
                <div className="circular-dates-container">
                    <div className="column-spacer" />
                    <div>
                        <div className="row-spacer" />
                        <div>
                            <div>Valid:</div>
                            <div>
                                {`${moment(props.headerInfo.startDate).format("MM/DD/YY")} - ${moment(
                                    props.headerInfo.endDate,
                                ).format("MM/DD/YY")}`}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
